/**
 * The launcher's tiles fill the box with no scrolling (v1's `WidgetLauncher`,
 * translated): try each column count and keep the one that gives the largest
 * square that fits both the width and the height. Class C — layout.
 */

export interface Fit {
  cols: number;
  size: number;
}

/** v1's cap, so a wide browser keeps a tidy block rather than huge tiles. */
export const MAX_WIDTH = 480;

export function fitTiles(
  width: number,
  height: number,
  count: number,
  gap: number,
  pad: number,
  maxWidth = MAX_WIDTH,
): Fit | null {
  const w = Math.min(width - pad * 2, maxWidth);
  const h = height - pad * 2;
  if (w <= 0 || h <= 0 || count <= 0) return null;
  let best: Fit = { cols: 1, size: 0 };
  for (let cols = 1; cols <= count; cols++) {
    const rows = Math.ceil(count / cols);
    const side = Math.min((w - gap * (cols - 1)) / cols, (h - gap * (rows - 1)) / rows);
    if (side > best.size) best = { cols, size: side };
  }
  return { cols: best.cols, size: Math.floor(best.size) };
}
